<template>
  <div class="main-content">

    <!-- Section: home -->
    <section id="home" class="divider">
      <!-- Hero Slider -->
      <div class="hero-slider" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
        <div
          v-for="(slide, index) in slides"
          :key="index"
          class="hero-slide"
          :class="['align-' + slide.align, { 'is-active': index === currentSlide }]"
        >
          <div
            class="hero-slide__bg"
            :style="{ backgroundImage: 'url(' + slide.image + ')', backgroundPosition: slide.position }"
          ></div>
          <div class="hero-slide__overlay"></div>

          <div class="hero-slide__content">
            <p v-if="slide.eyebrow" class="hero-slide__eyebrow">{{ slide.eyebrow }}</p>
            <h2 class="hero-slide__title">{{ slide.title }}</h2>
            <p v-for="(line, i) in slide.lines" :key="i" class="hero-slide__text">{{ line }}</p>
            <a v-if="slide.cta" class="btn btn-theme-colored hero-slide__cta" :href="slide.cta.href">
              {{ slide.cta.label }}
            </a>
          </div>
        </div>

        <!-- Arrows -->
        <button type="button" class="hero-arrow hero-arrow--prev" aria-label="Precedente" @click="prevSlide">
          <i class="fa fa-angle-left"></i>
        </button>
        <button type="button" class="hero-arrow hero-arrow--next" aria-label="Successivo" @click="nextSlide">
          <i class="fa fa-angle-right"></i>
        </button>

        <!-- Dots -->
        <div class="hero-dots">
          <button
            type="button"
            v-for="(slide, index) in slides"
            :key="index"
            class="hero-dot"
            :class="{ 'is-active': index === currentSlide }"
            :aria-label="'Vai alla slide ' + (index + 1)"
            @click="goToSlide(index)"
          ></button>
        </div>
      </div>
      <!-- Hero Slider Ends -->
    </section>


    <section id="trial" class="divider parallax  layer-overlay" data-parallax-ratio="0.7" v-if="!loggedIn">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-30 font-brooklyn-light">
                  ISCRIVITI E AVRAI ACCESSO ALL'AREA PERSONALE CON UN <span class="text-theme-colored">PROGRAMMA
                    GRATUITO</span> PER 7 GIORNI
                </h3>
                <a class="btn btn-theme-colored" href="/subscribe">ISCRIVITI</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Categories -->
    <section id="categories">
      <div class="container" v-if="results != null && results.length > 0">

        <!-- <div class="messageHomePayPal" data-pp-message data-pp-style-layout="flex" data-pp-style-ratio="20x1"
          data-pp-style-color="black">
        </div> -->
        <div class="row mtli-row-clearfix p-20" id="dashboardPrograms">
          <div class="col-sm-4 pb-20" v-for="category in results" :key="category.id">
            <a :href="'/category?Key=' + category.UrlKey"
              class="class-item box-hover-effect effect1 mb-md-30 bg-lighter category-item">
              <div class="thumb mb-20">
                <img :alt="category.Image[0].alternativeText" :src="baseUrl + category.Image[0].url"
                  class="img-fullwidth">
              </div>
              <div class="content text-left flip p-25 pt-0">
                <h4 class="text-uppercase font-weight-800 line-bottom">{{ category.Title }}</h4>
                <p>{{ category.ShortDescription }}</p>
                <a class="btn-read-more btn-sm">Scopri</a>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Categories -->
    <!-- <section id="callToAction" class="divider parallax layer-overlay"  data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10" style="text-align:center">                
                <video controls autoplay style="width:100%;">
                  <source src="/strapi/uploads/Sarah_insta_2_converted_medium_d0d3680d4e.mp4" type="video/mp4">                  
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->


    <section class="divider parallax  layer-overlay" data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-10 font-brooklyn-light">
                  Iscriviti alla <span class="text-theme-colored">newsletter</span>
                </h3>
                <label>Riceverai workout, tips tecnici e anteprime</label>
                <div class="row equal mt-10 align-items-center">
                  <div class="col-md-3">
                  </div>
                  <div class="col-md-6">
                    <div v-if="!NewsletterRequestSent">

                      <form id="newsletter_form" class="needs-validation" name="newsletter_form" @submit="sendNewsletter"
                        novalidate>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <!-- <label>E-mail <small>*</small></label> -->
                              <input name="newsletter_form_email" class="form-control required email" type="email"
                                v-model="Newsletter.Email" placeholder="Email *" required />
                            </div>
                          </div>
                        </div>

                        
                        <div class="row">
                          <div class="form-check col-md-12"> 
                            <input type="checkbox" required v-model="Newsletter.privacy" class="form-check-input"
                              id="chkPrivacy" />
                            <label class="form-check-label" for="chkPrivacy">Accetto le condizioni di privacy
                              <a class="text-theme-colored" target="_blank" href="/privacy">Leggi qui</a></label>
                          </div>
                          <div class="form-check col-md-12">
                            <input type="checkbox" v-model="Newsletter.condition" required class="form-check-input"
                              id="chkConditions" />
                            <label class="form-check-label" for="chkConditions">Accetto i termini e condizioni
                              <a class="text-theme-colored" target="_blank" href="/terms">Leggi qui</a></label>
                          </div>
                        </div>

                        <div class="row pt-10">
                          <div class="alert alert-danger" v-if="errorNewsletter">{{ errorNewsletter }}</div>
                        </div>

                        <div class="form-group">
                          <input name="form_botcheck" class="form-control" type="hidden" value="" />
                          <button type="submit" class="btn btn-dark btn-theme-colored btn-flat mr-5"
                            data-loading-text="Please wait...">Iscriviti</button>                          
                        </div>



                      </form>



                    </div>

                    <div class="vertical-center t-a-center" v-if="NewsletterRequestSent">
                      <h3 class="mt-0 mb-10 mt-sm-30">Grazie per esserti iscritto/a</h3>
                    </div>

                  </div>
                  <div class="col-md-3">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>







    <!-- Section: callToAction  -->
    <section id="callToAction" class="divider parallax  layer-overlay" data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-30 font-brooklyn-light">
                  Per chi lo desidera è possibile accedere ad un <span class="text-theme-colored">programma</span>
                  specifico <span class="text-theme-colored">personalizzato</span>,<br />
                  strettamente cucito sui propri obiettivi ed esigenze.
                </h3>
                <div class="row equal mt-40">
                  <div class="col-md-5">
                    <img class="img-fullwidth" src="images/202208/Sarah04.jpg" alt="">
                  </div>
                  <div class="col-md-7">
                    <div v-if="!SentEmail">
                      <h3 class="mt-15 mb-10 mt-sm-30">Inviami un messaggio</h3>

                      <form id="contact_form" class="needs-validation" name="contact_form" @reset="resetContact" @submit="sendContact"
                        novalidate>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Nome <small>*</small></label>
                              <input name="form_name" class="form-control" type="text" placeholder="Nome"
                                v-model="Contact.Name" required>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Email <small>*</small></label>
                              <input name="form_email" class="form-control required email" type="email"
                                v-model="Contact.Email" placeholder="Email" required>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Oggetto <small>*</small></label>
                              <input name="form_subject" class="form-control required" type="text"
                                v-model="Contact.Subject" placeholder="Oggetto" required>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Telefono</label>
                              <input name="form_phone" class="form-control" type="text" v-model="Contact.Phone"
                                placeholder="Telefono">
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Messaggio <small>*</small></label>
                          <textarea name="form_message" class="form-control required" rows="5" v-model="Contact.Message"
                            placeholder="Messaggio" required></textarea>
                        </div>

                        <div class="row">
                          <div class="form-check col-md-12">
                            <input type="checkbox" required v-model="Contact.privacy" class="form-check-input"
                              id="chkPrivacy" />
                            <label class="form-check-label" for="chkPrivacy">Accetto le condizioni di privacy
                              <a class="text-theme-colored" target="_blank" href="/privacy">Leggi qui</a></label>
                          </div>
                          <div class="form-check col-md-12">
                            <input type="checkbox" v-model="Contact.condition" required class="form-check-input"
                              id="chkConditions" />
                            <label class="form-check-label" for="chkConditions">Accetto i termini e condizioni
                              <a class="text-theme-colored" target="_blank" href="/terms">Leggi qui</a></label>
                          </div>
                        </div>

                        <div class="row pt-10">
                          <div class="alert alert-danger" v-if="error">{{ error }}</div>
                        </div>

                        <div class="form-group">
                          <input name="form_botcheck" class="form-control" type="hidden" value="" />
                          <button type="submit" class="btn btn-dark btn-theme-colored btn-flat mr-5"
                            data-loading-text="Please wait...">Invia messaggio</button>
                          <button type="reset" class="btn btn-default btn-flat btn-theme-colored">Svuota</button>
                        </div>
                      </form>
                    </div>
                    <div class="vertical-center t-a-center" v-if="SentEmail">
                      <h3 class="mt-0 mb-10 mt-sm-30">Grazie per avermi contattata, ti risponderò il prima possibile</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- Section: Categories -->
    <section id="reviews">

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-dark font-brooklyn-light t-a-center">
              COSA DICONO DI ME...
            </h3>
          </div>
        </div>



        <!-- https://tools.picsart.com/text/emojis/people/ -->

        <carousel :items="1" :margin="40" :nav="true"
          :navText="[`<i class='fa fa-chevron-left'></i>`, `<i class='fa fa-chevron-right'></i>`]"
          :responsive="{ 0: { items: 1, nav: true }, 600: { items: 2, nav: true } }" :dots="false">



          <div class="review-box">
            <div class="review-title">Grazie Sarah ❤️</div>
            <div class="review-description">
              Non è facile affidarsi a qualcuno che non si conosce...sopratutto iniziare un percorso online...ma è come se
              tu fossi sempre presente. Ti ho scelta tra tante e a distanza di un anno...lo farei ancora ❤️
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Mi sento meglio!!!</div>
            <div class="review-description">
              Mi sono accorta che rispetto agli allenamenti che facevo prima al box le mie gambe sono meno gonfie e i
              glutei si sono rimpolpati😅
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Sono passati 5 anni</div>
            <div class="review-description">
              Ciao Sarah...credo siano passati 5 anni...ma conservo ancora la maglia con molta cura, e la indosso con
              affetto perchè i bei percorsi e le belle persone rimangono sempre nel cuore ❤️
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Dopo la nostra chiacchierata</div>
            <div class="review-description">
              Il nostro confronto è stata una sorta di "medicina" per ripartire con ancora più volontà...Questo per
              esprimere la grande importanza di avere un rapporto diretto con la nostra coach...è davvero
              importante...L'allenamento è anche benessere mentale non solo fisico...e avere qualcuno che ti segue e ci
              tiene come te è "tanta roba"!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>


          <div class="review-box">
            <div class="review-title">Adoro gli allenamenti</div>
            <div class="review-description">
              Tornando agli allenamenti stanno andando una bomba, mi piacciono ogni mese di più e inizia a vedere anche
              qualche muscoletto niente male ☺️ da un pò ho iniziato anche a correre e ho scoperto che mi paice davvero
              tanto!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title">Gestione allenamenti</div>
            <div class="review-description">
              Una cosa bellissima dei tuoi allenamenti è che puoi gestirli ed è una cosa che mi fa stare bene....se non ho
              tempo di fare tutto posso dividerli.
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Ah Sarahhhh ieri i complimenti del fisioterapista a chi mi struttura gli allenamenti. Mai visto un addome
              tanto forte durante le terapie... oltre alla mobilità 🖐️😝
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Saraaaaaaaaaaaah<br />
              Ho iniziato il secondo mese del trimestrale! Queste schede mi piacciono ancora di più di primaaaa 🤩🤸‍♀️
              gli allenamenti sono stra vari, hanno dentro di tutto, non mi annoioooo, con la corsa sto facendo un po' di
              progressi forse 😅<br />
              Grazie grazie!<br />
              Devo impegnarmi a mandarti qualche video 🤞<br />
              Buona serata 😘
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Ciao Sarah 😍<br />
              Bello sentirti... 🥰<br />
              Fino ad ora ho fatto 4 allenamenti, va molto bene, mi piace moltissimo perchè io insegno yoga e avevo
              bisogno proprio di un mix!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Sudo anche l'anima ma che bellezza ❤️
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>

          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Per come sono fatta fisicamente credo di non aver mai avuto le gambe così leggere e sgonfie in vita mia, era
              una cosa che non mi faceva sentire in pace e a disagio spesso, ho capito e accettato che non posso cambiarle
              ma posso prendermene cura e fare i movimenti che le fanno stare bene ma soprattutto a vedere le mie gambe
              non tanto per come sono ma per quello che mi possono far fare, forti e muscolose mi supportano quando faccio
              trail in salita, e senza di loro per come sono fatte non andrei da nessuna parte 😊<br />
              Grazie per i tuoi programmi 😘
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>

          </div>

          <div class="review-box">
            <div class="review-title"></div>
            <div class="review-description">
              Ciao!!! Benissimo Sarah 😄 sto continuando ad essere costante e non mi pesa per niente anzi sono tornata
              finalmente a non vedere l'ora di allenarmi. <br><br>
              Sto seguendo gli allenamenti del box ma i tuoi esercizi di mobilità non li ho mai mollati!
            </div>
            <div class="review-source">
              <i class="fa fa-whatsapp"></i> WhatsApp
            </div>
          </div>

        </carousel>

      </div>
    </section>


    <!-- Section: Gallery -->
    <section id="gallery" class="divider parallax layer-overlay" v-if="gallery && gallery.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- Portfolio Gallery Grid -->
            <div class="gallery-isotope grid-3 masonry gutter-small clearfix" data-lightbox="gallery">

              <!-- Portfolio Item Start -->
              <div class="gallery-item" v-for="galleryImg in gallery" :key="galleryImg.id">
                <a :href="baseUrl + galleryImg.Image.url" data-lightbox="gallery-item" :title="galleryImg.Title"><img
                    :src="baseUrl + galleryImg.Image.url" alt=""></a>
              </div>
              <!-- Portfolio Item End -->
            </div>
            <!-- End Portfolio Gallery Grid -->
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<style scoped>
/* ============================= HERO SLIDER ============================= */
.hero-slider {
  position: relative;
  width: 100%;
  height: 88vh;
  min-height: 520px;
  max-height: 860px;
  overflow: hidden;
  background-color: #111;
}

.hero-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 1.2s ease;
  z-index: 1;
}

.hero-slide.is-active {
  opacity: 1;
  visibility: visible;
  z-index: 2;
}

.hero-slide__bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-repeat: no-repeat;
  transform: scale(1.05);
}

/* Slow Ken-Burns zoom on the active slide */
.hero-slide.is-active .hero-slide__bg {
  animation: heroZoom 7s ease-out forwards;
}

@keyframes heroZoom {
  from { transform: scale(1.05); }
  to { transform: scale(1.15); }
}

.hero-slide__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.15) 40%, rgba(0, 0, 0, 0.6) 100%);
}

.hero-slide__content {
  position: relative;
  z-index: 3;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 80px;
  color: #fff;
  text-shadow: 0 2px 18px rgba(0, 0, 0, 0.45);
}

.hero-slide.align-right .hero-slide__content {
  align-items: flex-end;
  text-align: right;
}

.hero-slide.align-left .hero-slide__content {
  align-items: flex-start;
  text-align: left;
}

/* Entrance animation for text on the active slide */
.hero-slide__eyebrow,
.hero-slide__title,
.hero-slide__text,
.hero-slide__cta {
  opacity: 0;
  transform: translateY(28px);
}

.hero-slide.is-active .hero-slide__eyebrow,
.hero-slide.is-active .hero-slide__title,
.hero-slide.is-active .hero-slide__text,
.hero-slide.is-active .hero-slide__cta {
  animation: heroFadeUp 0.9s ease forwards;
}

.hero-slide.is-active .hero-slide__title { animation-delay: 0.18s; }
.hero-slide.is-active .hero-slide__text { animation-delay: 0.32s; }
.hero-slide.is-active .hero-slide__cta { animation-delay: 0.5s; }

@keyframes heroFadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-slide__eyebrow {
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 1px;
  margin: 0 0 8px;
  opacity: 0.95;
}

.hero-slide__title {
  font-size: 64px;
  font-weight: 700;
  line-height: 1.05;
  margin: 0 0 22px;
  color: #fff;
}

.hero-slide.align-right .hero-slide__title,
.hero-slide.align-left .hero-slide__title {
  position: relative;
  padding-bottom: 18px;
}

.hero-slide.align-right .hero-slide__title::after,
.hero-slide.align-left .hero-slide__title::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 70px;
  height: 4px;
  border-radius: 2px;
  background-color: #EE163B;
}

.hero-slide.align-right .hero-slide__title::after { right: 0; }
.hero-slide.align-left .hero-slide__title::after { left: 0; }

.hero-slide__text {
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  margin: 0 0 10px;
  max-width: 560px;
}

.hero-slide__cta {
  margin-top: 26px;
  font-size: 16px;
  padding: 12px 38px;
  border-radius: 2px;
  letter-spacing: 1px;
}

/* Navigation arrows */
.hero-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 6;
  width: 52px;
  height: 52px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(4px);
  color: #fff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
}

.hero-arrow:hover {
  background: #EE163B;
}

.hero-arrow--prev { left: 24px; }
.hero-arrow--next { right: 24px; }

/* Dots */
.hero-dots {
  position: absolute;
  bottom: 26px;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  gap: 12px;
  /* the full-width strip must not steal clicks from the arrows underneath;
     only the dots themselves should be interactive */
  pointer-events: none;
}

.hero-dot {
  pointer-events: auto;
}

.hero-dot {
  width: 12px;
  height: 12px;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.hero-dot.is-active {
  background: #EE163B;
  border-color: #EE163B;
  transform: scale(1.15);
}

@media only screen and (max-width: 991px) {
  .hero-slide__title { font-size: 46px; }
  .hero-slide__text { font-size: 18px; }
}

@media only screen and (max-width: 767px) {
  .hero-slider {
    height: auto;
    min-height: 0;
    max-height: none;
  }
  .hero-slide {
    position: relative;
    opacity: 1;
    visibility: visible;
    display: none;
  }
  .hero-slide.is-active {
    display: block;
  }
  .hero-slide__content {
    position: relative;
    align-items: center !important;
    text-align: center !important;
    padding: 90px 22px 110px;
    min-height: 78vh;
    justify-content: center;
  }
  .hero-slide.align-right .hero-slide__title::after,
  .hero-slide.align-left .hero-slide__title::after {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
  .hero-slide__eyebrow { font-size: 15px; }
  .hero-slide__title { font-size: 34px; }
  .hero-slide__text { font-size: 16px; }

  /* On mobile move the arrows to the bottom corners (in line with the dots)
     so they never overlap the centered text */
  .hero-arrow {
    top: auto;
    bottom: 18px;
    transform: none;
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  .hero-arrow:hover { transform: none; }
  .hero-arrow--prev { left: 16px; }
  .hero-arrow--next { right: 16px; }
}

.owl-prev,
.owl-next {
  font-size: 30px;
  color: #4CAF50;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 10px;
  transition: background 0.3s ease;
}

.owl-prev:hover,
.owl-next:hover {
  background: #4CAF50;
  color: #fff;
}

.owl-prev {
  left: -40px;
  /* Spostamento a sinistra */
}

.owl-next {
  right: -40px;
  /* Spostamento a destra */
}

a.class-item {
  display: block;
}

.messageHomePayPal {
  margin-left: 15px;
  margin-right: 15px;
}

#categories {
  background-color: #e0e0e0;
}

#callToAction h3 {
  font-size: 22px;
}

#callToAction {
  background-color: #f5f5f5;
}

@media only screen and (max-width: 768px) {
  #callToAction h3 {
    font-size: 18px;
  }
}

.review-box {
  border: 1px solid #ddd;
  border-left: 5px solid #4CAF50;
  padding: 20px;
  margin: 20px auto;
  max-width: 600px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  font-family: 'Arial', sans-serif;
  border-radius: 8px;
  position: relative;
}

.review-title {
  font-size: 1.2em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.review-description {
  font-size: 1em;
  color: #555;
  margin-bottom: 15px;
}

.review-source {
  font-size: 0.9em;
  color: #888;
  text-align: right;
}

.owl-carousel {
  position: relative;
}


.review-source i {
  color: #25D366;
  /* Colore ufficiale WhatsApp */
  margin-right: 5px;
}

.form-check-input {
  margin-right: 0.5rem;
  position: relative;
  top: 5px;
  width: 1.2rem;
  height: 1.2rem;
}
</style>

<script>
import axios from "axios";
import carousel from "vue-owl-carousel";
import { THEMEMASCOT } from "../../public/js/custom.js";

export default {
  name: "Home",
  components: {
    carousel
  },
  data() {
    return {
      SentEmail: false,
      NewsletterRequestSent: false,
      error: "",
      errorNewsletter: "",
      Contact: {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
        condition: false,
        privacy: false,
      },
      Newsletter: {
        Email: "",
        condition: false,
        privacy: false,
      },
      results: [],
      baseUrl: process.env.VUE_APP_API_URL,
      gallery: [],
      loggedIn: !(localStorage.getItem('token') == undefined || localStorage.getItem('token') == null || localStorage.getItem('token') == ""),
      currentSlide: 0,
      slideTimer: null,
      slides: [
        {
          image: "images/202208/Sarah31.jpg",
          position: "35% 55%",
          align: "right",
          eyebrow: "Benvenuta nel mondo di",
          title: "Movement Flow",
          lines: [
            "Ti insegno a prenderti cura di te a 360°. Renderemo divertente e stimolante ciò che prima sembrava difficile e noioso."
          ],
          cta: { label: "Acquista", href: "/category?Key=MovementFlow" }
        },
        {
          image: "images/202208/Sarah89.jpg",
          position: "center 70%",
          align: "right",
          eyebrow: "Insieme ritroverai il tuo",
          title: "Equilibrio",
          lines: [
            "Consapevolezza, forza e movimento per affrontare con energia la vita di tutti i giorni."
          ]
        },
        {
          image: "images/202208/Sarah10.jpg",
          position: "center 25%",
          align: "left",
          eyebrow: "Il tuo rapporto con il cibo",
          title: "Sano e in armonia",
          lines: [
            "Equilibrio e moderazione sono la chiave. Insieme costruiremo un rapporto sereno con il cibo."
          ]
        },
        {
          image: "images/202208/Sarah113.jpg",
          position: "center 30%",
          align: "right",
          eyebrow: "Workout",
          title: "Realizza i tuoi obiettivi",
          lines: [
            "Troverai diversi percorsi per raggiungere i tuoi traguardi, passo dopo passo, al tuo ritmo."
          ]
        }
      ]
    };
  },
  methods: {
    goToSlide: function (index) {
      this.currentSlide = (index + this.slides.length) % this.slides.length;
      this.startAutoplay();
    },
    nextSlide: function () {
      this.goToSlide(this.currentSlide + 1);
    },
    prevSlide: function () {
      this.goToSlide(this.currentSlide - 1);
    },
    startAutoplay: function () {
      this.stopAutoplay();
      this.slideTimer = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      }, 6000);
    },
    stopAutoplay: function () {
      if (this.slideTimer) {
        clearInterval(this.slideTimer);
        this.slideTimer = null;
      }
    },
    resetContact: function () {
      this.error = "";
      this.Contact = {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
        Phone: "",
        condition: false,
        privacy: false,
      };
    },
    sendContact: function () {

      this.error = "";

      if (
        !this.Contact.privacy || !this.Contact.condition) {
        this.error = "Accetta privacy e condizioni";
        return;
      }

      var form = document.getElementById('contact_form');
      if (form.checkValidity()) {
        axios.post(process.env.VUE_APP_API_URL + "/utility/contactme", this.Contact).then(response => {
          this.SentEmail = response.data.ok;
        });
      }
    },
    subscribeToMailchimp: function (email) {
      return new Promise((resolve, reject) => {
        const mailchimpUrl = process.env.VUE_APP_MAILCHIMP_URL;
        if (!mailchimpUrl) {
          console.warn('Mailchimp URL non configurato in VUE_APP_MAILCHIMP_URL');
          resolve({ result: 'skipped' });
          return;
        }
        const tag = process.env.VUE_APP_MAILCHIMP_TAG;
        let url = mailchimpUrl + '&EMAIL=' + encodeURIComponent(email) + '&c=mailchimpCallback';
        if (tag) {
          url += '&tags=' + encodeURIComponent(tag);
        }
        const callbackName = 'mailchimpCallback';

        window[callbackName] = function (data) {
          delete window[callbackName];
          document.head.removeChild(script);
          if (data.result === 'success') {
            resolve(data);
          } else {
            reject(data);
          }
        };

        console.log('url')
        console.log(url)
        const script = document.createElement('script');
        script.src = url;
        script.onerror = function () {
          delete window[callbackName];
          document.head.removeChild(script);
          reject({ msg: 'Errore di connessione a Mailchimp' });
        };
        document.head.appendChild(script);
      });
    },
    sendNewsletter: function () {
      this.errorNewsletter = "";

      if (
        !this.Newsletter.privacy || !this.Newsletter.condition) {
        this.errorNewsletter = "Accetta privacy e condizioni";
        return;
      }

      var form = document.getElementById('newsletter_form');
      if (form.checkValidity()) {
        // Salva su Strapi
        axios.post(process.env.VUE_APP_API_URL + "/utility/subscribeNewsletter", this.Newsletter).then(response => {
          console.log(response.data);
          if (response.data.ok == true) {
            // Iscrivi anche a Mailchimp
            this.subscribeToMailchimp(this.Newsletter.Email).then(() => {
              console.log('Iscritto a Mailchimp con successo');
            }).catch(err => {
              console.warn('Mailchimp:', err.msg || err);
            });
            this.NewsletterRequestSent = true;
          }
          else {
            this.errorNewsletter = "La mail che hai inserito è già presente.";
          }
        });
      }
    }
  },
  mounted() {

    this.startAutoplay();

    var form = document.getElementById('contact_form');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      form.classList.add('was-validated');
    }, false);


    var formNewsletter = document.getElementById('newsletter_form');
    formNewsletter.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      form.classList.add('was-validated');
    }, false);



    axios.get(process.env.VUE_APP_API_URL + "/categories?IsVisible=true").then(response => {
      this.results = response.data;
    });

    axios.get(process.env.VUE_APP_API_URL + "/home-galleries").then(response => {
      this.gallery = response.data;
      console.log("Gallery:", this.gallery);
      THEMEMASCOT.widget.init();
    });
  },
  beforeDestroy() {
    this.stopAutoplay();
  }
};
</script>
